interface GameIntroOverlayProps {
  gameName: string;
  cognitiveTag: string;
  onDismiss: () => void;
}

export default function GameIntroOverlay({
  gameName,
  cognitiveTag,
  onDismiss,
}: GameIntroOverlayProps) {
  return (
    <div
      className="absolute inset-0 z-50 flex items-center justify-center px-6 bg-foreground-950/60 backdrop-blur-md animate-fade-in"
      onClick={onDismiss}
    >
      <div className="w-full bg-white rounded-2xl border border-primary-200 px-6 py-7 flex flex-col items-center justify-between text-center min-h-[320px] max-h-[78vh] animate-pop-in">
        <div className="w-full pt-2">
          <p className="text-lg font-bold text-foreground-900 leading-relaxed">
            음성 테스트 전,
            <br />
            가볍게 두뇌 풀기 게임을 진행할게요!
          </p>

          <div className="mt-6">
            <p className="text-xs text-foreground-500">이번 두뇌 풀기 게임</p>
            <h2 className="text-lg font-semibold text-foreground-900 mt-1">{gameName}</h2>
            <span className="inline-block mt-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
              #{cognitiveTag}
            </span>
          </div>
        </div>

        <div className="flex flex-col items-center gap-2.5 pb-1">
          <div className="relative w-12 h-12 flex items-center justify-center">
            <span className="absolute inset-0 rounded-full bg-primary-500/20 touch-ripple" />
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-fingerprint-line text-xl leading-none" />
            </div>
          </div>
          <p className="text-xs text-foreground-500">화면을 터치해 계속하기</p>
        </div>
      </div>
    </div>
  );
}